import React from "react";
import { Mail, MapPin, Instagram, Facebook } from "lucide-react";

export default function Footer({ onQuoteClick }) {
  return (
    <footer id="contact" data-testid="footer" className="bg-[#0D0D0D] border-t border-[#333] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-20">
          <div className="lg:col-span-7">
            <div className="text-xs tracking-[0.3em] uppercase text-[#FF5A00] font-bold mb-4">
              [ 05 ] Ready When You Are
            </div>
            <h2 className="font-heading uppercase text-white text-5xl lg:text-7xl leading-[0.9] tracking-tighter">
              Let's Get<br />
              You Fenced.
            </h2>
            <p className="text-[#A3A3A3] text-lg mt-8 max-w-xl">
              Free quote, on-site measure, and no-pressure conversation. Most
              quotes land in your inbox within 24 hours.
            </p>
            <button
              data-testid="footer-quote-btn"
              onClick={onQuoteClick}
              className="mt-10 bg-[#FF5A00] text-black font-heading tracking-[0.2em] uppercase px-8 py-5 hover:bg-[#E65100] transition-colors text-base"
            >
              Start My Free Quote →
            </button>
          </div>

          <div className="lg:col-span-5 space-y-px bg-[#333]">
            <a
              href="mailto:Tradesmandanvic@gmail.com"
              data-testid="footer-email"
              className="bg-[#1A1A1A] hover:bg-[#262626] flex items-start gap-5 p-6 transition-colors group"
            >
              <Mail className="w-6 h-6 text-[#FF5A00] shrink-0 mt-1" />
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">Email</div>
                <div className="font-heading text-white text-xl uppercase tracking-tight group-hover:text-[#FF5A00] transition-colors break-all">
                  Tradesmandanvic@gmail.com
                </div>
              </div>
            </a>
            <div className="bg-[#1A1A1A] flex items-start gap-5 p-6">
              <MapPin className="w-6 h-6 text-[#FF5A00] shrink-0 mt-1" />
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">Service Area</div>
                <div className="font-heading text-white text-xl uppercase tracking-tight">
                  South East VIC + Gippsland
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#333] pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-[#FF5A00] flex items-center justify-center font-heading text-black">
              TD
            </div>
            <div className="text-xs tracking-[0.2em] uppercase text-[#A3A3A3]">
              © {new Date().getFullYear()} TradesmanDan · ABN Pending · All Rights Reserved
            </div>
          </div>
          <div className="flex items-center gap-4">
            <a href="#" aria-label="Instagram" className="text-white/60 hover:text-[#FF5A00] transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="#" aria-label="Facebook" className="text-white/60 hover:text-[#FF5A00] transition-colors">
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href="/admin/login"
              data-testid="footer-admin-link"
              className="text-[10px] tracking-[0.3em] uppercase text-white/30 hover:text-[#FF5A00] ml-4"
            >
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
